import React from "react";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { AppointmentPhase } from "components";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";

const GroundTransportFromTo = ({ groundTransport }: { groundTransport: server.dto.GroundTransportForList }) => {

  const startDateWritten = formatWrittenDayMonthYear(groundTransport.start.dateTimeLocal);
  const endDateWritten = formatWrittenDayMonthYear(groundTransport.end.dateTimeLocal);

  const startTimeWritten = formatTime(groundTransport.start.dateTimeLocal);
  const endTimeWritten = formatTime(groundTransport.end.dateTimeLocal);

  const arrivalDateAndTime = startDateWritten === endDateWritten
    ? endTimeWritten
    : `${endDateWritten} ${endTimeWritten}`;

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {startDateWritten}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.start.placeName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.start.placeAddress}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {startTimeWritten}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        {arrivalDateAndTime}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.end.placeName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.end.placeAddress}
      </div>
    </div>
  </div>;
};

export const cardLayout = (onShowChange: () => void): ListTemplateLayout<server.dto.GroundTransportForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <LargeClickableTitle
        uri={routes.groundTransport_Detail(item.id).absolute}
        icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
        title={item.title}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <GroundTransportFromTo groundTransport={item} />
      <LinkedShowsList onChange={onShowChange} shows={item.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        {item.artists.map((artist, index) => <React.Fragment key={artist.artistId}>
          <span>{artist.name}</span>
          {item.artists.length - 1 !== index && <span>, </span>}
        </React.Fragment>)}
      </div>
      <div>
        {item.travellers.map((traveller, index) => <React.Fragment key={traveller.contactId}>
          <span className="s1_gray">{traveller.name.fullName}</span>
          {item.travellers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => item.artists.length === 0 && item.travellers.length === 0
  }
});